export const LANGS = [
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
];

export const translations = {
  nl: {
    nav: { how: "Hoe het werkt", about: "Over ons", products: "Producten", plans: "Abonnementen", contact: "Contact", order: "Bestel nu" },
    hero: {
      tag: "NFC-oplossingen voor apotheken",
      l1: "Eén tik.",
      l2: "Meer bereik.",
      l3: "Meer klanten.",
      sub: "aponiqo verbindt uw toonbank met uw sociale media. Klanten tikken hun telefoon tegen de toonbank en zijn één klik verwijderd van je te volgen, te liken of een review achter te laten.",
      cta: "Ontdek de pods",
      cta2: "Vraag advies aan",
    },
    marquee: ["Instagram", "Facebook", "Google reviews", "Educatieve NFC toepassingen - binnenkort"],
    manifesto: {
      title: "Waarom apotheken kiezen voor aponiqo",
      items: [
        { t: "Laagdrempelig", d: "Uw klant hoeft niets te zoeken of te typen. Eén tik met de telefoon en ze zijn verbonden met uw pagina." },
        { t: "Meer volgers", d: "Zet elke bezoeker aan de toonbank om in een online volger. Uw bereik groeit vanzelf, elke dag." },
        { t: "Geen onderhoud", d: "De NFC-pods zijn zeer duurzaam en hebben geen onderhoud nodig. U koopt ze slechts één keer aan." },
        { t: "Elegante uitstraling", d: "De vierkante (12 x 12 cm) NFC-pods hebben dankzij hun acryl-laag een glanzende look waardoor ze professioneel ogen, in tegenstelling tot een QR-code op een blad papier." },
      ],
    },
    about: {
      title: "Over ons",
      lead: "In tijden waar het snel en makkelijk moet gaan.",
      p: [
        "Steeds meer apotheken willen hun zichtbaarheid op Facebook, Instagram en Google Reviews vergroten. Toch blijft het online bereik vaak beperkt.",
        "Het probleem? De drempel is simpelweg te hoog. Het moet snel, eenvoudig en zonder extra moeite kunnen. Bovendien worden patiënten in de apotheek vaak onvoldoende gewezen op de online kanalen van hun apotheek. Hoe vaak neemt een zichtbaar tevreden patiënt thuis nog de tijd om een review achter te laten? In een tijd waarin mensen dagelijks uren op hun smartphone doorbrengen, is het dan ook een gemiste kans om de digitale zichtbaarheid van de apotheek niet optimaal te benutten.",
        "Met onze NFC-pods maken we dit proces eenvoudig en laagdrempelig. Door hun attractieve look nodigen ze de patiënt uit tot interactie. De patiënt houdt zijn smartphone kort tegen de pod en wordt onmiddellijk naar de gewenste online pagina geleid. Zo kan hij of zij met één simpele tik, gewoon aan de toog, een review achterlaten of uw apotheek volgen op sociale media.",
        "Een kleine tik voor de patiënt, een grote stap voor uw online zichtbaarheid.",
      ],
      features: [
        { t: "Google Reviews", d: "laat eenvoudig een review achter" },
        { t: "Instagram", d: "volg de apotheek en blijf op de hoogte" },
        { t: "Facebook", d: "bezoek en volg de pagina" },
      ],
      closing1: "Geen QR-code scannen, niets intypen en niets opzoeken.",
      closing2: "Tik. Klik. Klaar.",
      extraP: [
        "Daarnaast zijn we volop bezig met de ontwikkeling van onze EUB-NFC-pods.",
        "Deze pods werken volgens hetzelfde eenvoudige principe: de patiënt houdt zijn smartphone tegen de pod en wordt onmiddellijk doorgestuurd naar de juiste digitale informatie.",
        "Zo krijgt de patiënt bijvoorbeeld rechtstreeks toegang tot een instructievideo over het gebruik van Wegovy, Mounjaro of Ozempic. Geen zoektocht op YouTube, maar met één simpele tik de juiste uitleg op het scherm.",
        "Zo wordt de eerste-uitgiftebegeleiding in de apotheek eenvoudiger en kan de patiënt de instructievideo thuis op zijn gemak opnieuw bekijken.",
      ],
      extraClosing: "Eén tik. De juiste uitleg. Altijd binnen handbereik",
    },
    how: {
      title: "Hoe werkt een NFC pod?",
      intro: "Een NFC pod maakt gebruik van Near Field Communication (NFC) technologie om eenvoudig informatie over te dragen naar een smartphone.",
      steps: [
        { t: "Tik", d: "De klant houdt de telefoon bij de NFC-pod op uw toonbank." },
        { t: "Verbind", d: "De telefoon opent meteen uw sociale media of reviewpagina." },
        { t: "Groei", d: "Meer volgers, meer reviews, meer betrokken klanten." },
      ],
    },
    products: {
      title: "Kies uw NFC-pods",
      sub: "Duurzame pods, klaar voor gebruik. Inclusief configuratie van uw links.",
      note: "U laat naargelang het type NFC-pod de naam van uw apotheek op Facebook, Instagram en/of Google achter bij het afsluiten van de verkoop. Vervolgens configureren wij de chip met de link naar uw Instagram-/Facebookpagina en/of Google Reviews-sectie en sturen de NFC-pods op.",
      volumeNote: "Volumekorting — combineer vrij: 1 pod € 39 · 2 pods € 69 · 3 pods € 95.",
      shippingNote: "Gratis verzending bij iedere aankoop!",
      bulkNote: "Voor apotheek-ketens en grotere volumes: vul onderstaand formulier in en ontvang een offerte op maat.",
      add: "In winkelmand",
      items: {
        nfc_google: { name: "NFC Toonbankpod Google Review", desc: "Laat klanten met één tik een Google-review achterlaten en versterk zo de online reputatie van uw apotheek." },
        nfc_facebook: { name: "NFC Toonbankpod Facebook", desc: "Laat klanten uw apotheek met één tik volgen op Facebook — meer bereik, zonder zoeken of typen." },
        nfc_instagram: { name: "NFC Toonbankpod Instagram", desc: "Laat klanten uw apotheek met één tik volgen op Instagram en groei uw community." },
        nfc_complete: { name: "NFC Complete Package", desc: "Maximaliseer al uw social media kanalen met de complete package: Google Review, Facebook én Instagram in één voordelig pakket." },
      },
    },
    plans: {
      title: "Onderhoudsabonnementen",
      sub: "Wij houden uw links, campagnes en pods up-to-date.",
      month: "/maand",
      subscribe: "Abonneer",
      items: {
        maintenance_basic: { name: "Basis", features: ["Link-updates op aanvraag", "Kwartaalcontrole pods", "E-mailsupport"] },
        maintenance_pro: { name: "Pro", features: ["Onbeperkte link-updates", "Maandelijkse campagne-afstemming", "Vervanging bij schade", "Prioritaire support"] },
      },
      popular: "Populair",
    },
    cart: {
      title: "Winkelmand", empty: "Uw winkelmand is leeg.", total: "Totaal", checkout: "Afrekenen",
      pharmacy: "Naam apotheek", address: "Afleveradres", email: "E-mailadres", vat: "BTW-/ondernemingsnummer", qty: "Aantal", processing: "Bezig...",
      fields: { website: "Naam apotheek + stad waarin gevestigd", facebook: "Naam Facebookpagina", instagram: "Naam instagrampagina" },
      display: { title: "Display voor je NFC-pods", desc: "Stevige witte toonbankdisplay om je pods op te plakken.", add: "Toevoegen", perPiece: "per stuk" },
      fillRequired: "Vul de gevraagde gegevens per pod in om af te rekenen.",
      addMore: "Voeg meer toe",
    },
    contact: {
      title: "Welke vragen heeft u nog?", sub: "Laat uw gegevens achter en we nemen binnen 24 uur contact op.",
      name: "Uw naam", pharmacy: "Apotheek", email: "E-mailadres", phone: "Telefoon (optioneel)",
      message: "Uw bericht", send: "Verstuur aanvraag", sent: "Bedankt! We nemen snel contact op.", error: "Er ging iets mis. Probeer opnieuw.",
    },
    footer: { tagline: "NFC-pods die apotheken online laten groeien.", rights: "Alle rechten voorbehouden." },
    success: { title: "Bedankt voor uw bestelling!", sub: "We hebben uw betaling ontvangen. U ontvangt een bevestiging per e-mail.", back: "Terug naar home", checking: "Betaling controleren..." },
    cancel: { title: "Betaling geannuleerd", sub: "Uw betaling is niet voltooid. U kunt het opnieuw proberen.", back: "Terug naar home" },
  },
  en: {
    nav: { how: "How it works", about: "About us", products: "Products", plans: "Plans", contact: "Contact", order: "Order now" },
    hero: {
      tag: "NFC solutions for pharmacies",
      l1: "One tap.",
      l2: "More reach.",
      l3: "More customers.",
      sub: "aponiqo connects your counter to your social media. Customers tap their phone on the counter and are just one tap away from following you, liking your page or leaving a review.",
      cta: "Explore the pods",
      cta2: "Request advice",
    },
    marquee: ["Instagram", "Facebook", "Google reviews", "Educational NFC applications - coming soon"],
    manifesto: {
      title: "Why pharmacies choose aponiqo",
      items: [
        { t: "Effortless", d: "Your customer doesn't have to search or type. One tap and they're connected to your page." },
        { t: "More followers", d: "Turn every counter visitor into an online follower. Your reach grows on its own, every day." },
        { t: "No maintenance", d: "The NFC pods are highly durable and require no maintenance. You only purchase them once." },
        { t: "Elegant look", d: "Thanks to their acrylic layer, the NFC pods have a glossy look that appears professional, unlike a QR code on a sheet of paper." },
      ],
    },
    about: {
      title: "About us",
      lead: "In times when everything has to be fast and easy.",
      p: [
        "More and more pharmacies want to boost their visibility on Facebook, Instagram and Google Reviews. Yet online reach often stays limited, even though a large number of regular patients visit every week.",
        "The problem? The barrier is simply too high. It has to be quick and easy. On top of that, patients in the pharmacy are often insufficiently informed about the pharmacy's online channels. How often does a visibly satisfied patient actually take the time at home to leave a review? Moreover, many patients aren't sufficiently aware that their pharmacy is active on social media and regularly shares interesting information, promotions and updates there. In a time when people look at their screens for hours every day, it's a missed opportunity not to make the most of that digital visibility.",
        "With our NFC pods we make this process simple and effortless. Their attractive look invites the patient to interact. The patient briefly holds their smartphone against the pod and is instantly taken to the desired online page. This way, with one simple tap, right at the counter, they can leave a review or follow your pharmacy on social media.",
        "A small tap for the patient, a big step for your online visibility.",
      ],
      features: [
        { t: "Google Reviews", d: "easily leave a review" },
        { t: "Instagram", d: "follow the pharmacy and stay up to date" },
        { t: "Facebook", d: "visit and follow the page" },
      ],
      closing1: "No QR code to scan, nothing to type and nothing to look up.",
      closing2: "Tap. Click. Done.",
      extraP: [
        "In addition, we are hard at work developing our EUB NFC pods.",
        "These pods work on the same simple principle: the patient holds their smartphone against the pod and is instantly directed to the right digital information.",
        "For example, the patient gets direct access to an instruction video on how to use Wegovy, Mounjaro or Ozempic. No searching on YouTube — just one simple tap for the right explanation on screen.",
        "This makes first-dispensing guidance in the pharmacy easier, and the patient can rewatch the instruction video at home at their own pace.",
      ],
      extraClosing: "One tap. The right explanation. Always within reach",
    },
    how: {
      title: "How does an NFC pod work?",
      intro: "An NFC pod uses Near Field Communication (NFC) technology to easily transfer information to a smartphone.",
      steps: [
        { t: "Tap", d: "The customer holds their phone near the NFC pod on your counter." },
        { t: "Connect", d: "The phone instantly opens your social media or review page." },
        { t: "Grow", d: "More followers, more reviews, more engaged customers." },
      ],
    },
    products: {
      title: "Choose your NFC pods",
      sub: "Durable, ready to use pods. Includes configuration of your links.",
      note: "Depending on the type of NFC pod, you leave your pharmacy's name on Facebook, Instagram and/or Google when completing your order. We then configure the chip with the link to your Instagram/Facebook page and/or Google Reviews section and ship the NFC pods to you.",
      volumeNote: "Volume discount — mix freely: 1 pod € 39 · 2 pods € 69 · 3 pods € 95.",
      shippingNote: "Free shipping on every order!",
      bulkNote: "For pharmacy chains and larger volumes: fill in the form below and receive a tailored quote.",
      add: "Add to cart",
      items: {
        nfc_google: { name: "NFC Counter Pod Google Review", desc: "Let customers leave a Google review with one tap and strengthen your pharmacy's online reputation." },
        nfc_facebook: { name: "NFC Counter Pod Facebook", desc: "Let customers follow your pharmacy on Facebook with one tap — more reach, no searching or typing." },
        nfc_instagram: { name: "NFC Counter Pod Instagram", desc: "Let customers follow your pharmacy on Instagram with one tap and grow your community." },
        nfc_complete: { name: "NFC Complete Package", desc: "Maximise all your social media channels with the complete package: Google Review, Facebook and Instagram in one great-value bundle." },
      },
    },
    plans: {
      title: "Maintenance plans",
      sub: "We keep your links, campaigns and pods up to date.",
      month: "/month",
      subscribe: "Subscribe",
      items: {
        maintenance_basic: { name: "Basic", features: ["Link updates on request", "Quarterly pod check", "Email support"] },
        maintenance_pro: { name: "Pro", features: ["Unlimited link updates", "Monthly campaign tuning", "Replacement on damage", "Priority support"] },
      },
      popular: "Popular",
    },
    cart: {
      title: "Cart", empty: "Your cart is empty.", total: "Total", checkout: "Checkout",
      pharmacy: "Pharmacy name", address: "Delivery address", email: "Email address", vat: "VAT / company number", qty: "Qty", processing: "Processing...",
      fields: { website: "Pharmacy name + city", facebook: "Facebook page name", instagram: "Instagram page name" },
      display: { title: "Display for your NFC pods", desc: "Sturdy white counter display to stick your pods on.", add: "Add", perPiece: "each" },
      fillRequired: "Fill in the requested details for each pod to check out.",
      addMore: "Add more",
    },
    contact: {
      title: "Any questions left?", sub: "Leave your details and we'll get in touch within 24 hours.",
      name: "Your name", pharmacy: "Pharmacy", email: "Email address", phone: "Phone (optional)",
      message: "Your message", send: "Send request", sent: "Thank you! We'll be in touch soon.", error: "Something went wrong. Please try again.",
    },
    footer: { tagline: "NFC pods that help pharmacies grow online.", rights: "All rights reserved." },
    success: { title: "Thank you for your order!", sub: "We received your payment. You'll get a confirmation by email.", back: "Back to home", checking: "Verifying payment..." },
    cancel: { title: "Payment cancelled", sub: "Your payment was not completed. You can try again.", back: "Back to home" },
  },
  fr: {
    nav: { how: "Comment ça marche", about: "À propos", products: "Produits", plans: "Abonnements", contact: "Contact", order: "Commander" },
    hero: {
      tag: "Solutions NFC pour pharmacies",
      l1: "Un geste.",
      l2: "Plus de portée.",
      l3: "Plus de clients.",
      sub: "aponiqo connecte votre comptoir à vos réseaux sociaux. Les clients approchent leur téléphone du comptoir et ne sont qu'à un clic de vous suivre, d'aimer votre page ou de laisser un avis.",
      cta: "Découvrir les pods",
      cta2: "Demander conseil",
    },
    marquee: ["Instagram", "Facebook", "Avis Google", "Applications NFC éducatives - bientôt"],
    manifesto: {
      title: "Pourquoi les pharmacies choisissent aponiqo",
      items: [
        { t: "Sans effort", d: "Votre client n'a rien à chercher ni à taper. Un geste et il est connecté à votre page." },
        { t: "Plus d'abonnés", d: "Transformez chaque visiteur du comptoir en abonné en ligne. Votre portée grandit chaque jour." },
        { t: "Aucun entretien", d: "Les pods NFC sont très durables et ne nécessitent aucun entretien. Vous ne les achetez qu'une seule fois." },
        { t: "Aspect élégant", d: "Grâce à leur couche acrylique, les pods NFC ont un aspect brillant et professionnel, contrairement à un QR code sur une feuille de papier." },
      ],
    },
    about: {
      title: "À propos",
      lead: "À une époque où tout doit être rapide et simple.",
      p: [
        "De plus en plus de pharmacies souhaitent accroître leur visibilité sur Facebook, Instagram et Google Reviews. Pourtant, la portée en ligne reste souvent limitée, alors qu'un grand nombre de patients fidèles passent chaque semaine.",
        "Le problème ? La barrière est tout simplement trop élevée. Cela doit être rapide et facile. De plus, les patients en pharmacie sont souvent insuffisamment informés des canaux en ligne de la pharmacie. Combien de fois un patient visiblement satisfait prend-il encore le temps, chez lui, de laisser un avis ? En outre, de nombreux patients ne sont pas suffisamment conscients que leur pharmacie est active sur les réseaux sociaux et y partage régulièrement des informations, des promotions et des actualités intéressantes. À une époque où les gens regardent leur écran des heures chaque jour, c'est une occasion manquée de ne pas exploiter pleinement cette visibilité numérique.",
        "Avec nos pods NFC, nous rendons ce processus simple et accessible. Grâce à leur look attrayant, ils invitent le patient à l'interaction. Le patient approche brièvement son smartphone du pod et est immédiatement dirigé vers la page en ligne souhaitée. Ainsi, en un simple geste, directement au comptoir, il peut laisser un avis ou suivre votre pharmacie sur les réseaux sociaux.",
        "Un petit geste pour le patient, un grand pas pour votre visibilité en ligne.",
      ],
      features: [
        { t: "Google Reviews", d: "laissez facilement un avis" },
        { t: "Instagram", d: "suivez la pharmacie et restez informé" },
        { t: "Facebook", d: "visitez et suivez la page" },
      ],
      closing1: "Pas de QR code à scanner, rien à taper et rien à chercher.",
      closing2: "Tik. Clic. Terminé.",
      extraP: [
        "Par ailleurs, nous développons activement nos pods NFC EUB.",
        "Ces pods fonctionnent selon le même principe simple : le patient approche son smartphone du pod et est immédiatement redirigé vers la bonne information numérique.",
        "Le patient accède ainsi par exemple directement à une vidéo d'instructions sur l'utilisation de Wegovy, Mounjaro ou Ozempic. Pas de recherche sur YouTube, mais la bonne explication à l'écran en un simple geste.",
        "L'accompagnement de première délivrance en pharmacie devient ainsi plus simple, et le patient peut revoir la vidéo tranquillement chez lui.",
      ],
      extraClosing: "Un geste. La bonne explication. Toujours à portée de main",
    },
    how: {
      title: "Comment fonctionne un pod NFC ?",
      intro: "Un pod NFC utilise la technologie Near Field Communication (NFC) pour transférer facilement des informations vers un smartphone.",
      steps: [
        { t: "Approcher", d: "Le client approche son téléphone du pod NFC sur votre comptoir." },
        { t: "Connecter", d: "Le téléphone ouvre aussitôt vos réseaux sociaux ou votre page d'avis." },
        { t: "Grandir", d: "Plus d'abonnés, plus d'avis, plus de clients engagés." },
      ],
    },
    products: {
      title: "Choisissez vos pods NFC",
      sub: "Pods durables, prêts à l'emploi. Configuration de vos liens incluse.",
      note: "Selon le type de pod NFC, vous indiquez le nom de votre pharmacie sur Facebook, Instagram et/ou Google lors de la finalisation de la commande. Nous configurons ensuite la puce avec le lien vers votre page Instagram/Facebook et/ou votre section Google Reviews, puis nous vous envoyons les pods NFC.",
      volumeNote: "Remise sur volume — combinez librement : 1 pod 39 € · 2 pods 69 € · 3 pods 95 €.",
      shippingNote: "Livraison gratuite pour chaque commande !",
      bulkNote: "Pour les chaînes de pharmacies et les gros volumes : remplissez le formulaire ci-dessous et recevez un devis sur mesure.",
      add: "Ajouter au panier",
      items: {
        nfc_google: { name: "Pod de comptoir Google Review", desc: "Laissez les clients déposer un avis Google en un geste et renforcez la réputation en ligne de votre pharmacie." },
        nfc_facebook: { name: "Pod de comptoir Facebook", desc: "Laissez les clients suivre votre pharmacie sur Facebook en un geste — plus de portée, sans rien chercher." },
        nfc_instagram: { name: "Pod de comptoir Instagram", desc: "Laissez les clients suivre votre pharmacie sur Instagram en un geste et développez votre communauté." },
        nfc_complete: { name: "NFC Complete Package", desc: "Maximisez tous vos réseaux sociaux avec le pack complet : Google Review, Facebook et Instagram dans un seul pack avantageux." },
      },
    },
    plans: {
      title: "Abonnements d'entretien",
      sub: "Nous gardons vos liens, campagnes et pods à jour.",
      month: "/mois",
      subscribe: "S'abonner",
      items: {
        maintenance_basic: { name: "Basique", features: ["Mises à jour des liens sur demande", "Contrôle trimestriel des pods", "Support par e-mail"] },
        maintenance_pro: { name: "Pro", features: ["Mises à jour illimitées", "Réglage mensuel des campagnes", "Remplacement en cas de dommage", "Support prioritaire"] },
      },
      popular: "Populaire",
    },
    cart: {
      title: "Panier", empty: "Votre panier est vide.", total: "Total", checkout: "Payer",
      pharmacy: "Nom de la pharmacie", address: "Adresse de livraison", email: "Adresse e-mail", vat: "N° TVA / entreprise", qty: "Qté", processing: "En cours...",
      fields: { website: "Nom de la pharmacie + ville", facebook: "Nom de la page Facebook", instagram: "Nom de la page Instagram" },
      display: { title: "Présentoir pour vos pods NFC", desc: "Présentoir de comptoir blanc et solide pour y coller vos pods.", add: "Ajouter", perPiece: "pièce" },
      fillRequired: "Renseignez les informations demandées pour chaque pod avant de payer.",
      addMore: "Ajouter plus",
    },
    contact: {
      title: "Vous avez encore des questions ?", sub: "Laissez vos coordonnées et nous vous contactons sous 24 h.",
      name: "Votre nom", pharmacy: "Pharmacie", email: "Adresse e-mail", phone: "Téléphone (optionnel)",
      message: "Votre message", send: "Envoyer la demande", sent: "Merci ! Nous vous contactons bientôt.", error: "Une erreur est survenue. Réessayez.",
    },
    footer: { tagline: "Des pods NFC qui font grandir les pharmacies en ligne.", rights: "Tous droits réservés." },
    success: { title: "Merci pour votre commande !", sub: "Nous avons reçu votre paiement. Vous recevrez une confirmation par e-mail.", back: "Retour à l'accueil", checking: "Vérification du paiement..." },
    cancel: { title: "Paiement annulé", sub: "Votre paiement n'a pas abouti. Vous pouvez réessayer.", back: "Retour à l'accueil" },
  },
};
